<template>
  <el-dialog
    width="50%"
    title="修改课程分类"
    ref="dialog"
    v-model="dialogVisible"
    :before-close="handleClose"
  >
    <el-cascader-panel
      v-model="courseCategory"
      v-loading="loading"
      :options="options"
      :props="props"
      :show-all-levels="false"
      style="width: 100%"
      collapse-tags-tooltip
      clearable
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelForm">关闭</el-button>
        <el-button :disabled="loading" type="primary" @click="submitForm"
          >确认</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {
  GetCategoryListById,
  GetDataCourseCategoryList,
} from "@api/Company/ApiUser";
import { GetCourseCategoryListById } from "@api/ApiCourseCategory";
export default {
  components: {},
  props: {
    dialogVisible: false,
    formData: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.getCategoryList();
    this.getUserCategory();
  },
  data() {
    return {
      props: {
        multiple: true,
        expandTrigger: "hover",
        value: "id",
        label: "name",
        children: "childs",
      },
      loading: false,
      courseCategory: [],
      options: [],
    };
  },
  methods: {
    getUserCategory() {
      const params = {
        pageSize: 10000,
        pageIndex: 1,
        queryModel: { userId: this.formData.id },
      };
      GetCategoryListById(JSON.stringify(params)).then((res) => {
        let funList = [];
        res.entities.forEach((item) => {
          funList.push(this.getCategoryParentId(item.courseCategory));
        });
        Promise.all(funList).then((data) => {
          this.loading = false;
          this.courseCategory = data;
        });
      });
    },
    // 获取父级id
    async getCategoryParentId(id) {
      const res = await GetCourseCategoryListById(id);
      return [res.cc1, id];
    },
    getCategoryList() {
      const params = {
        pageSize: 10000,
        pageIndex: 1,
        queryModel: {},
      };
      this.loading = true;
      GetDataCourseCategoryList(params).then((res) => {
        this.options = res;
      });
    },
    submitForm() {
      const list = this.courseCategory.map((item) => item[item.length - 1]);
      this.$emit("category-submitForm", list);
    },
    cancelForm() {
      this.handleClose();
    },
    handleClose() {
      this.$emit("category-close");
    },
    handleCancel() {
      handleClose();
    },
  },
};
</script>
<style scoped>
</style>
